module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-spinner/gatsby-browser.js'),
      options: {"plugins":[],"top":"20px","left":"10px","theme":"light"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
